module.exports = __webpack_public_path__ + "img/aParty_110923_G.7753c23e.jpg";